// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"3da2d3f9","390":"c4fb8d3f","770":"f147fe0d"}[chunkId] + ".chunk.js";
};